/* eslint-disable */
export default (initialState: any, handlers: any) => (state = initialState, action: any = {}) => {
	if (action.hasOwnProperty('type') && handlers[action.type]) {
		return handlers[action.type](state, action);
	}
	return state;
};
